<template>

  <div class="container">
    <!--
    <appheader></appheader>
    -->
    <b-container class="bv-example-row pt-3" :is="currentComponent" :swap-component="swapComponent">
    </b-container>  

    <b-container class="mt-4" id="startbutton">
      <b-row>
        <b-col class="pb-2 text-center"><b-button variant="primary" size="lg" @click="swapComponent()">Let's Get Started</b-button></b-col>
      </b-row>
    </b-container>

    <appfooter></appfooter>    

  </div>

</template>

<script>
import AppHeader from "./AppHeader.vue"
import AppFooter from "./AppFooter.vue"
import AppWizard from "./Wizard.vue"
import Welcome from "./Welcome.vue"

export default {
  name: 'app',
  components: {
    appheader: AppHeader,
    appfooter: AppFooter,
    Welcome: Welcome,
    wizard: AppWizard
  },
  data() {
    return {
      currentComponent: Welcome
    }
  },
  methods: {
    swapComponent: function() {
      this.currentComponent = 'wizard';
      document.getElementById("startbutton").style.display = 'none';
    }
  }  
}
</script>





// WEBPACK FOOTER //
// src/App.vue